// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__YzcO-","content_container":"ErrorPage_content_container__OU7wH","image_container":"ErrorPage_image_container__rjzd1","text":"ErrorPage_text__imTbw"};